export default function SocialLinks({ link, color, type }) {
  const svgColor = color.primary_font;

  let insta = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 448.25 448.15"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M224.1,141A114.9,114.9,0,1,0,339,255.9,114.718,114.718,0,0,0,224.1,141Zm0,189.6a74.7,74.7,0,1,1,74.7-74.7,74.836,74.836,0,0,1-74.7,74.7ZM370.5,136.3a26.8,26.8,0,1,1-26.8-26.8A26.738,26.738,0,0,1,370.5,136.3Zm76.1,27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9,0C95.8,35.1,64,43.3,37.7,69.5s-34.4,58-36.2,93.9c-2.1,37-2.1,147.9,0,184.9,1.7,35.9,9.9,67.7,36.2,93.9s58,34.4,93.9,36.2c37,2.1,147.9,2.1,184.9,0,35.9-1.7,67.7-9.9,93.9-36.2,26.2-26.2,34.4-58,36.2-93.9,2.1-37,2.1-147.8,0-184.8ZM398.8,388a75.627,75.627,0,0,1-42.6,42.6c-29.5,11.7-99.5,9-132.1,9s-102.7,2.6-132.1-9A75.627,75.627,0,0,1,49.4,388c-11.7-29.5-9-99.5-9-132.1s-2.6-102.7,9-132.1A75.628,75.628,0,0,1,92,81.2c29.5-11.7,99.5-9,132.1-9s102.7-2.6,132.1,9a75.628,75.628,0,0,1,42.6,42.6c11.7,29.5,9,99.5,9,132.1S410.5,358.6,398.8,388Z"
        transform="translate(0.075 -31.825)"
        fill={svgColor}
      />
    </svg>
  );

  let fb = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 496 493"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M504,256C504,119,393,8,256,8S8,119,8,256C8,379.78,98.69,482.38,217.25,501V327.69h-63V256h63V201.36c0-62.15,37-96.48,93.67-96.48,27.14,0,55.52,4.84,55.52,4.84v61H335.16c-30.8,0-40.41,19.12-40.41,38.73V256h68.78l-11,71.69H294.75V501C413.31,482.38,504,379.78,504,256Z"
        transform="translate(-8 -8)"
        fill={svgColor}
      />
    </svg>
  );

  let snap = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="307.095"
      height="302.458"
      viewBox="0 0 307.095 302.458"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M350.963,325.18l-.078.095a30.59,30.59,0,0,1-8.239,6.449,85.312,85.312,0,0,1-19.458,7.751,12,12,0,0,0-3.641,1.663c-2.04,1.8-1.985,4.386-4.159,8.081a21.868,21.868,0,0,1-6.465,7.062c-6.339,4.378-13.463,4.653-21.012,4.943-6.819.259-14.546.549-23.373,3.468-3.555,1.177-7.328,3.492-11.7,6.175-10.648,6.522-25.218,15.457-49.433,15.457s-38.682-8.885-49.25-15.387c-4.4-2.73-8.2-5.068-11.855-6.276-8.827-2.911-16.556-3.214-23.374-3.469-7.548-.29-14.672-.567-21.012-4.942a21.819,21.819,0,0,1-5.681-5.775c-3.025-4.378-2.7-7.372-4.966-9.353a12.693,12.693,0,0,0-3.875-1.734,85.052,85.052,0,0,1-19.2-7.682,31.1,31.1,0,0,1-7.845-5.94c-6.222-6.387-7.822-13.966-5.374-20.628,3.248-8.826,10.937-11.447,18.337-15.371,13.966-7.587,24.9-17.065,32.546-28.246a64.5,64.5,0,0,0,5.657-9.988c.746-2.04.73-3.147.228-4.174a6.981,6.981,0,0,0-2.087-2.1c-2.393-1.584-4.833-3.169-6.5-4.253-3.091-2.024-5.546-3.609-7.116-4.707-5.923-4.143-10.066-8.544-12.665-13.464a26.843,26.843,0,0,1-1.294-22.291c3.907-10.325,13.676-16.735,25.5-16.735a35.1,35.1,0,0,1,7.415.785c.651.142,1.295.29,1.93.456-.1-7.023.055-14.515.682-21.852,2.229-25.767,11.259-39.309,20.675-50.089a82.076,82.076,0,0,1,21.059-16.948c14.305-8.157,30.428-12.3,48.092-12.3s33.864,4.143,48.152,12.3a82.392,82.392,0,0,1,21.02,16.919c9.415,10.781,18.446,24.3,20.675,50.09a218.51,218.51,0,0,1,.674,21.851c.636-.164,1.287-.314,1.939-.455a35.1,35.1,0,0,1,7.414-.785c11.815,0,21.569,6.41,25.493,16.735a26.815,26.815,0,0,1-1.323,22.268c-2.59,4.915-6.733,9.32-12.656,13.463-1.577,1.122-4.025,2.707-7.116,4.708-1.734,1.122-4.292,2.785-6.771,4.425a6.479,6.479,0,0,0-1.844,1.923c-.478.989-.509,2.071.157,3.977a65.233,65.233,0,0,0,5.751,10.2c7.815,11.437,19.081,21.09,33.511,28.74,1.4.73,2.817,1.418,4.2,2.134.682.314,1.483.721,2.354,1.229,4.631,2.574,8.7,5.681,10.827,11.487C358.267,311.575,356.8,318.934,350.963,325.18Zm-15.8-17.449c-47.555-22.981-55.135-58.524-55.472-61.2-.407-3.194-.871-5.7,2.652-8.953,3.4-3.146,18.47-12.467,22.651-15.386,6.928-4.834,9.957-9.659,7.713-15.591-1.569-4.079-5.374-5.648-9.415-5.648a17.485,17.485,0,0,0-3.774.423c-7.595,1.647-14.97,5.453-19.238,6.481a6.711,6.711,0,0,1-1.569.212c-2.276,0-3.1-1.012-2.919-3.751.533-8.3,1.663-24.5.353-39.638-1.781-20.824-8.5-31.142-16.476-40.265-3.829-4.371-21.867-23.3-56.273-23.3s-52.4,19.009-56.225,23.4c-7.972,9.125-14.68,19.442-16.477,40.265-1.31,15.135-.133,31.33.353,39.638.157,2.6-.643,3.751-2.919,3.751a6.711,6.711,0,0,1-1.569-.212c-4.26-1.027-11.635-4.833-19.231-6.48a17.488,17.488,0,0,0-3.774-.424c-4.017,0-7.845,1.546-9.415,5.649-2.244,5.932.8,10.757,7.72,15.59,4.182,2.919,19.254,12.248,22.652,15.387,3.515,3.249,3.06,5.759,2.647,8.952-.336,2.637-7.924,38.18-55.472,61.2-2.785,1.35-7.524,4.206.832,8.82,13.119,7.21,21.844,6.434,28.639,10.8,5.759,3.712,2.363,11.715,6.544,14.6,5.155,3.554,20.4-.251,40.014,6.238,16.477,5.429,26.575,20.808,55.731,20.808s39.5-15.407,55.707-20.769c19.66-6.489,34.868-2.683,40.015-6.238,4.19-2.888.777-10.89,6.544-14.6,6.787-4.371,15.511-3.592,28.639-10.843C342.709,311.991,337.97,309.135,335.16,307.731Z"
        fill={svgColor}
        transform="translate(-49.879 -83.866)"
      />
    </svg>
  );
  let youtube = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="35"
      viewBox="0 0 546.134 384"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M549.655,124.083a68.622,68.622,0,0,0-48.284-48.6C458.781,64,288,64,288,64S117.22,64,74.629,75.486a68.624,68.624,0,0,0-48.284,48.6C14.933,166.95,14.933,256.388,14.933,256.388s0,89.438,11.412,132.3c6.281,23.65,24.787,41.5,48.284,47.821C117.22,448,288,448,288,448s170.78,0,213.371-11.486c23.5-6.321,42-24.171,48.284-47.821,11.412-42.867,11.412-132.3,11.412-132.3s0-89.438-11.412-132.3ZM232.145,337.591V175.185L374.884,256.39l-142.739,81.2Z"
        transform="translate(-14.933 -64)"
        fill={svgColor}
      />
    </svg>
  );

  let defaultLink = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="604.35"
      height="470.31"
      viewBox="0 0 604.35 470.31"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M579.8,267.7A144.6,144.6,0,0,0,393.5,47.8l-1.6,1.1a31.968,31.968,0,0,0,37.2,52l1.6-1.1A80.6,80.6,0,0,1,534.5,222.4L422.3,334.8A80.6,80.6,0,0,1,299.7,231l1.1-1.6a31.968,31.968,0,0,0-52-37.2l-1.1,1.6A144.519,144.519,0,0,0,467.5,380ZM60.2,244.3A144.6,144.6,0,0,0,246.5,464.2l1.6-1.1a31.968,31.968,0,0,0-37.2-52l-1.6,1.1A80.633,80.633,0,0,1,105.5,289.5L217.7,177.2A80.627,80.627,0,0,1,340.3,281.1l-1.1,1.6a31.968,31.968,0,1,0,52,37.2l1.1-1.6A144.551,144.551,0,0,0,172.5,132Z"
        transform="translate(-17.825 -20.845)"
        fill={svgColor}
      />
    </svg>
  );

  function linkType() {
    switch (type) {
      case "fb":
        return fb;
      case "snap":
        return snap;
      case "insta":
        return insta;
      case "youtube":
        return youtube;
      default:
        return defaultLink;
    }
  }

  if (!link) return null;
  return (
    <div className="social-links-container">
      <a className="social-links" href={link} target="_blank" rel="noreferrer">
        {linkType()}
      </a>
    </div>
  );
}
